<script>
	// NPM Modules
	import { tick } from 'svelte';
	// Components
	import Icon from '@/Components/Icon.svelte';
	// Partials
	import ManageMultiGroup from '@/Partials/Sport/Manage/MultiControl/_ManageMultiGroup.svelte';
	// Stores
	import MultiGroupStore from '@/Stores/Sport/MultiGroupStore';

	export let sport;

	let showMultiGroup = false;
	let selectedMultiGroup = undefined;

	MultiGroupStore.getMultiGroupsForSport(sport.id);

	async function openMultiGroupManage(multiGroupId) {
		selectedMultiGroup = multiGroupId;
		showMultiGroup = true;
		await tick();
		window.scrollTo(0, 0);
	}
</script>

{#if showMultiGroup}
	<ManageMultiGroup bind:open={showMultiGroup} bind:sport bind:multiGroupId={selectedMultiGroup} />
{/if}

<div class="flex items-center justify-end w-full">
	<button on:click={() => openMultiGroupManage()} class="btn btn-primary">Create new multi group</button>
</div>

<table class="w-full whitespace-nowrap mt-3">
	<thead>
		<tr class="text-xs text-left text-gray-500 uppercase">
			<th class="px-6 pt-3 pb-2 font-medium">Name</th>
			<th class="w-px px-6 pt-3 pb-2 font-medium text-left">Market types in group</th>
			<th class="w-px px-6 pt-3 pb-2 font-medium text-left">Sports</th>
			<th class="w-px px-6 pt-3 pb-2 font-medium text-left">Market types</th>
			<th class="w-px px-6 pt-3 pb-2 font-medium text-right" />
		</tr>
	</thead>
	<tbody class="bg-white">
		{#each $MultiGroupStore.where('id', '!=', 'create').all() as multiGroup (multiGroup.id)}
			<tr
				on:click={() => {
					selectedMultiGroup = multiGroup;
					openMultiGroupManage(multiGroup.id);
				}}
				class="cursor-pointer hover:bg-gray-100 focus-within:bg-gray-100"
			>
				<td class="p-4 px-6 border-t">
					<div class="flex items-center">
						<div class="mr-2 font-semibold">{multiGroup.name}</div>
					</div>
				</td>
				<td class="w-px px-6 border-t">
					{(multiGroup.excluded_market_types.data && multiGroup.excluded_market_types.data.count()) ?? 0}
				</td>
				<td class="w-px px-6 border-t text-xs">
					{(multiGroup.excluded_market_types.data &&
						multiGroup.excluded_market_types.data.pluck('sport.name').unique().join(', ')) ??
						''}
				</td>
				<td class="w-px px-6 border-t text-xs">
					{(multiGroup.excluded_market_types.data &&
						multiGroup.excluded_market_types.data
							.map((marketType) => {
								return `${marketType.name} [${marketType.sport.name}]`;
							})
							.join(', ')) ??
						''}
				</td>
				<td class="w-px px-6 border-t" style="max-width: 50%;">
					<Icon name="chevron-right" classes="block w-4 h-4 text-gray-400 inline" />
				</td>
			</tr>
		{:else}
			<tr>
				<td class="px-6 py-4 text-center border-t" colspan="9">
					No multi groups found for {sport.name}.
				</td>
			</tr>
		{/each}
	</tbody>
</table>
